import { API } from "./axiosInstance"

/**
 * Gets all the usergroups with joined tables from usermanagement-service
 * @returns the usergroups with joined objects
 */
export const getUsergroups = async () => {
  const applications = await API.get(`/usergroups`);
  return applications.data;
}

export const getOne = async (staticId) => {
    const usergroup = await API.get(`/usergroups/${staticId}`);
    return usergroup.data;
}

/**
 * Calls the post usergroup endpoint
 * @param {*} group the group to create
 * @returns the response from usermanagement-service
 */
export const createGroup = async (group) => {
    const createdGroup = await API.post('/usergroups', group);
    return createdGroup;
}

/**
 * Gets all the usergroups with joined tables for one member from usermanagement-service
 * @param {*} staticMemberId The member to get all the contacts for
 * @returns the usergroups with joined objects
 */
export const getGroupsforMember= async (staticMemberId) => {
    const contactpersonen = await API.get(`/usergroups?memberId=${staticMemberId}`);
    return contactpersonen.data;
}

/**
 * Calls the update usergroup endpoint
 * @param {*} group the usergroup to update
 * @returns the updated usergroup
 */
export const updateGroup = async(group, staticId) => {
    const updatedGroup = await API.put(`/usergroups/${staticId}`, group);
    return updatedGroup;
}

/**
 * Accepts a requested change for a usergroup
 * @param {*} staticId the id of the usergroup in the static model
 * @returns the accepted usergroup
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/usergroups/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for a usergroup
 * @param {*} staticId the id of the usergroup in the static model
 * @returns the rejected usergroup
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/usergroups/${staticId}/reject`);
    return response.data;
}